import { Typography } from "@mui/material";
import { TextInput } from "react-admin";
import { validateStreamGroup } from "utils/validations";

const StudyGroupField = ({ label, required, labelStyle, isRequired = false, validate, source = "studyGroups" }) => {
  return (
    <>
      <TextInput
        source={source}
        label="Учебни групи"
        placeholder="e.g., 1-5, 8, 11-13, 15"
        validate={[validateStreamGroup(isRequired), validate].filter(Boolean)}
        sx={{ mb: 0 }}
        required={required}
      />
      <Typography
        color={"primary"}
        sx={labelStyle}
      >
        {label}
      </Typography>
    </>
  );
};

export default StudyGroupField;
